var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.191 4.299a1.054 1.054 0 1 0-1.49-1.49L10 8.509l-5.701-5.7a1.054 1.054 0 1 0-1.49 1.49L8.509 10l-5.7 5.701a1.054 1.054 0 0 0 1.49 1.49l5.701-5.7 5.701 5.7a1.054 1.054 0 0 0 1.49-1.49L11.491 10l5.7-5.701Z",
    fill: "currentColor"
  })));
};
export default SvgClose;